import { BG_STYLES, COMMON_STYLES, CrossIcon } from '@dehaat/dds'
import React from 'react'
import { PropsWithChildren } from 'react'
import { Modal, Pressable, StyleSheet, View, ViewStyle } from 'react-native'
import { StyleProp } from 'react-native'

export interface CenterModalProps {
  allowClose?: boolean
  isVisible: boolean
  onClose: () => void
  style?: StyleProp<ViewStyle>
  viewStyle?: StyleProp<ViewStyle>
}

/**
 *
 * @param props
 */
export function CenterModal({
  allowClose = true,
  children,
  isVisible,
  onClose,
  style,
  viewStyle,
}: PropsWithChildren<CenterModalProps>) {
  return (
    <View>
      <Modal
        animationType="slide"
        onRequestClose={() => allowClose && onClose()}
        transparent
        visible={isVisible}
      >
        <View
          style={[
            COMMON_STYLES.alignItemsCenter,
            COMMON_STYLES.flex1,
            COMMON_STYLES.justifyCenter,
            styles.background,
            viewStyle,
          ]}
        >
          <View
            style={[
              BG_STYLES.bgWhite,
              COMMON_STYLES.alignItemsCenter,
              COMMON_STYLES.p1,
              COMMON_STYLES['br1'],
              styles.container,
              style,
            ]}
          >
            <View
              style={[
                COMMON_STYLES.alignItemsCenter,
                COMMON_STYLES.fullHeight,
                COMMON_STYLES.fullWidth,
                COMMON_STYLES.justifyCenter,
                COMMON_STYLES['p1/2'],
              ]}
            >
              {allowClose && (
                <Pressable
                  onPress={onClose}
                  style={({ pressed }) => [
                    pressed ? COMMON_STYLES['opacity1/2'] : undefined,
                    COMMON_STYLES.alignItemsEnd,
                    COMMON_STYLES.fullWidth,
                  ]}
                >
                  <CrossIcon fill="none" height={25} width={25} />
                </Pressable>
              )}

              {children}
            </View>
          </View>
        </View>
      </Modal>
    </View>
  )
}

const styles = StyleSheet.create({
  background: {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
  container: {
    width: 336,
  },
})
